// local storage
export const GAMES_LIST_CACHED = 'GLC'
export const YOLO_TOKEN_APPROVAL = 'YTKN'
export const TRANSACTIONS = 'TXS'
export const LOCAL_WALLET_KEY = 'LWK'
export const USERNAMES = 'USRN'
export const XFT_LEVELS = 'NFTLVLS'
export const ACCESS_TOKEN = 'ATKN'
export const WALLET_RECONNECT = 'WRCT'
export const GA_CLIENT_ID = 'GACID'
export const RANDOM_USERNAME_CACHED = 'RUC'
export const RANDOM_AVATAR_CACHED = 'RAC'
export const USER_LOGIN_INFO = 'ULGNI'
export const ONE_TIME_MODAL = 'OTM'
export const USER_PREFERENCES = 'UPREF'
export const LVG_PERSISTANCE_STATE = 'LVGSTT'
export const HI_LO_CHIP_SELECTION = 'HLCSEL'
